import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  // LinkIcon
} from '../'
import Styles from './Works.css'
import config from '../../config'

@CSSModules(Styles)
export default class Works extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    const iconOne = require('../../../static/images/icons_step1_blue.svg')
    const iconTwo = require('../../../static/images/icons_step2_blue.svg')
    const iconThree = require('../../../static/images/icons_step3_blue.svg')
    const iconFour = require('../../../static/images/icons_step4_blue.svg')

    return (
      <div styleName='works-wrap'>
        <div styleName='works'>
          <div styleName='works-inner'>
            <div styleName='works-title'>
              How to make your investments align with your values
            </div>
            <div styleName='works-steps-photos'>
              <div styleName='works-steps'>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step one icon'
                    src={iconOne}
                  />
                  <div styleName='works-step-title'>1</div>
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.clean}
                        title={'Search funds | '+config.app.title}
                        strong
                      >
                        Search for mutual funds and exchange-traded funds
                        (ETFs)
                      </Link>
                    </span> by name, ticker, or asset manager. Our database
                    covers 3,000 stock funds available in the U.S.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step two icon'
                    src={iconFour}
                  />
                  <div styleName='works-step-title'>2</div>
                  <div styleName='works-step-info'>
                    See your results. For each fund, we scan which companies
                    the fund invests in, and calculate a fund gender equality score. Then, we rank funds against others with a similar investment profile, and apply a gender equality grade based on those group rankings.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step three icon'
                    src={iconTwo}
                  />
                  <div styleName='works-step-title'>3</div>
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.clean}
                        title={'Search funds | '+config.app.title}
                        strong
                      >
                        Look for options that align with your values.
                      </Link>
                    </span> Sort and compare to find funds that fit your
                    investing needs.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step four icon'
                    src={iconThree}
                  />
                  <div styleName='works-step-title'>4</div>
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.toolkit}
                        title={'Action toolkit | '+config.app.title}
                        strong
                      >
                        Talk to your financial advisor or retirement plan
                        manager
                      </Link>
                    </span> about gender-lens investing.
                  </div>
                </div>
              </div>
              <div
                styleName='works-photo'
                title='How to make your investments match your values'
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

